import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-bar gfu-layout-bar--bottom" }
const _hoisted_2 = { class: "gfu-project-bottom-bar _ai-st" }
const _hoisted_3 = { class: "_flexcol _grow-1 _gap-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_button = _resolveComponent("skeleton-button")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_skeleton_wrapper, { class: "_flex _pt-2 _px-2 _pb-1 _gap-6 _bgc--white" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_skeleton_line),
            _createVNode(_component_skeleton_line, { height: 23 })
          ]),
          _createVNode(_component_skeleton_button, { class: "_grow-1" })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}